export const isPlaidTokenValid = (plaidTokenLastUpdated: string): boolean => {
  const lastUpdated = new Date(plaidTokenLastUpdated);
  const now = new Date();
  const diff = Math.abs(now.getTime() - lastUpdated.getTime());
  const diffDays = Math.ceil(diff / (1000 * 3600 * 24));

  return diffDays < 30;
};
